<template>
    <div>

        <rkm-form
            ref="FormEquipe"
            show-legend
        >

            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">

                    <rkm-form-select
                        :options="areas"
                        textField="text"
                        valueField="id"
                        label="INE / Área"
                        v-model="model.areaId"
                        :validations="validations.areaId"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">

                    <rkm-form-select
                        :options="microareas"
                        textField="text"
                        valueField="id"
                        label="Microárea"
                        v-model="model.microareaId"
                        :validations="validations.microareaId"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">

                    <rkm-form-select
                        :options="data.form.unidades"
                        text-field="descricao"
                        valueField="id"
                        label="Unidade"
                        v-model="model.unidadeId"
                        :validations="validations.unidadeId"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nome"
                        v-model="model.infraestruturaId"
                        :validations="validations.infraestruturaId"
                        valueField="id"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col class="flex-grow-0 text-nowrap">

                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.FormEquipe.validate(add)"
                    >
                        incluir
                    </rkm-button>

                    <rkm-button
                        v-if="altearacao"
                        :label="false"
                        color="danger"
                        @click="limpaFormulario()"
                    >
                        Cancelar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :items=data.model.equipe.equipes
            :fields="fields"
            ref="Table"
        >

            <template v-slot:cell(areaDescricao)="{ item }">
                {{ item.areaDescricao ? item.areaDescricao : 'Não informada' }}
            </template>

            <template v-slot:cell(microareaDescricao)="{ item }">
                {{ item.microareaDescricao ? item.microareaDescricao : 'Não informada' }}
            </template>

            <template v-slot:cell(numeroIne)="{ item }">
                {{ item.numeroIne ? item.numeroIne.padStart(10, '0') : '' }}
            </template>

            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                    title="Profissionais"
                    color="primary"
                    @click="$refs.ModalProfissional.open(item)"
                    small
                >
                    <rkm-icon
                        icon="users"
                    />
                </rkm-button>

                <rkm-button
                    :disabled="item.usuarios.length > 0"
                    @click.stop="handleDestroy(item)"
                    color="danger"
                    title="Excluir"
                    small
                >
                    <rkm-icon icon="trash"/>
                </rkm-button>
            </template>
        </rkm-table>

        <ModalProfissional
            ref="ModalProfissional"
            :data="data"
        />
    </div>
</template>

<script>

// Mixins
import { object } from "@/mixins";

// Modal
import ModalProfissional from './components/profissional/Modal'

export default {
    components: {
        ModalProfissional,
    },
    computed: {
        validations() {

            return {
                areaId: { required: true },
                microareaId: { required: false },
                unidadeId: { required: true },
                infraestruturaId: { required: true },
            }
        },
        areas() {
            return this.data.model.area.areas
                .filter(area => !!area.id && !isNaN(area.id))
                .map(area => {
                    const numeroIne = area.numeroIne ? area.numeroIne.padStart(10, '0') : '0000000000';

                    area.text = area.descricao
                        ? numeroIne + ' / ' + area.descricao
                        : numeroIne;

                    return area;
                });
        },
        microareas() {

            const microareas = []

            this.data.model.area.areas
                .filter(area => area.id == this.model.areaId)
                .map(area => {

                    area.microareas
                        .filter(microarea => !!microarea.id)
                        .map(microarea => {

                            microareas.push({
                                id: microarea.id,
                                text: microarea.descricao,
                            })
                    })
                })

            return microareas
        },
        fields() {

            return [
                { key: 'numeroIne', label: 'INE', sortable: true },
                { key: 'areaTipo', label: 'Tipo', sortable: true },
                { key: 'areaDescricao', label: 'Área', sortable: true },
                { key: 'microareaDescricao', label: 'Microárea', sortable: true },
                { key: 'unidadeDescricao', label: 'Unidade', sortable: true },
                { key: 'infraestruturaDescricao', label: 'Local de atendimento', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        },
        infraestruturas() {

            if (this.model.unidadeId) {

                let infraestrutura = this.data.form.unidades.find(u => u.id === this.model.unidadeId).infraestruturas

                this.handleInfraestrutura(infraestrutura)

                return infraestrutura
            }

            return []
        },
    },
    data: () => ({
        altearacao: false,
        index: null,
        model: {
            areaId: null,
            microareaId: null,
            unidadeId: null,
            infraestruturaId: null,
        }
    }),
    methods: {
        async validate() {

            return true
        },
        async verificaDuplicidade() {

            const existeEquipe = this.data.model.equipe.equipes
                .find(
                    equipe => equipe.areaId == this.model.areaId &&
                    equipe.microareaId == this.model.microareaId &&
                    equipe.unidadeId == this.model.unidadeId &&
                    equipe.infraestruturaId == this.model.infraestruturaId
                )

            if (existeEquipe) {

                this.showValidationNotification(`A equipe já existe.`)

                return false
            }

            return true
        },
        add() {

            this.verificaDuplicidade().then(isValid => {

                if (!isValid) return

                const area = this.clone(
                    this.data.model.area.areas
                        .find(area => area.id == this.model.areaId)
                )

                const microarea =
                    this.clone(
                        area.microareas
                            .find(microarea => microarea.id == this.model.microareaId)
                    )
                    || null

                const unidade = this.clone(
                    this.data.form.unidades
                        .find(unidade => unidade.id == this.model.unidadeId)
                )

                const infraestrutura = this.infraestruturas.find(u => u.id === this.model.infraestruturaId)

                const equipe = {
                    id: null,
                    areaId: area.id,
                    areaDescricao: area.descricao,
                    numeroIne: area.numeroIne,
                    areaTipo: area.tipoDescricao,
                    microareaId: microarea ? microarea.id : null,
                    microareaDescricao: microarea ? microarea.descricao : null,
                    unidadeId: unidade.id,
                    unidadeDescricao: unidade.descricao,
                    infraestruturaId: infraestrutura.id,
                    infraestruturaDescricao: infraestrutura.nome,
                    usuarios: [],
                }

                this.data.model.equipe.equipes.push(equipe)

                this.showSaveNotification('Equipe incluída com sucesso!')

                this.limpaFormulario()
            })
        },
        limpaFormulario() {

            this.model.areaId = null
            this.model.microareaId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null

            this.$nextTick()
                .then(() => this.$refs.FormEquipe.resetValidator())
        },
        handleDestroy(item) {

            const objIndex = this.data.model.equipe.equipes.findIndex((obj => obj.id == item.id));

            const destroy = async () => this.data.model.equipe.equipes.splice(objIndex, 1)

            this.showDeleteConfirmation(
                `Deseja realmente excluir a equipe com o` + ` INE: <strong>${ item.numeroIne }</strong>, ` +
                `Área: <strong>${ item.areaDescricao }</strong>, ` +
                `Tipo: <strong>${ item.areaTipo }</strong> e Unidade: <strong>${ item.unidadeDescricao }</strong>? `,
                destroy, this.handleError
            );
        },
        handleInfraestrutura(infraestrutura) {

            if (infraestrutura.length === 1) {
                this.model.infraestruturaId = infraestrutura[0].id
            } else {
                this.model.infraestruturaId = null
            }
        },
    },
    mixins: [ object ],
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        'model.areaId': function(areaId) {

            if (areaId) {

                this.model.microareaId = null
            }
        },
    },
}
</script>